import React from 'react';
import Immutable from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const PopupNode = ({ entity }) => {
  return (
    <div className="PopupNode">
      {entity.getIn(['body', 0, 'processed']) ? (
        <WysiwygField
          property="schema:text"
          className="PopupNode__body"
          html={entity.getIn(['body', 0, 'processed'], '')}
        />
      ) : null}
      <div className="Paragraphs">
        {
          entity.getIn(['field_paragraphs'], Immutable.List()).map((item) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>
    </div>
  );
};

export default PopupNode;
